import Pqp from "../../3x1010/Pqp.js";
import { stringToTokenList } from "../../helpers/helpers.js";

/**
 * Mom, can we have VirtualSelect?
 * No, we have VirtualSelect at home
 * VirtualSelect at home:
 *
 * */
export default class VirtualList {
  constructor(container, { options, entryHeight, optionsContainerHeight, valueKey, labelKey, titleKey, hasSearch, searchCallback = null, removeDiacritics = false, isSelect, numberOfRows, callback, ctaLabel }) {
    if (typeof container === "string") {
      this.container = document.querySelector(container);
    } else if (typeof container === "object") {
      this.container = container;
    } else {
      throw new Error("The first argument must be either a string or HTMLElement");
    }

    this.options = options;
    this.valueKey = valueKey;
    this.labelKey = labelKey;
    this.titleKey = titleKey;
    this.entryHeight = entryHeight;
    this.totalHeight = this.options.length * this.entryHeight;

    // if select we create a toggler button
    this.isSelect = isSelect;
    this.select = null;
    this.btnClearSelect = null;

    if (this.isSelect) {
      this.defaultSelectLabel = ctaLabel ? ctaLabel : "Seleziona un valore...";
      this.select = this.setupSelect();
      this.btnClearSelect = this.setupBtnClearSelect();
      this.listVisible = false;
    }

    // input search
    this.hasSearch = hasSearch;
    this.inputSearch = this.hasSearch ? this.setupInputSearch() : null;
    this.searchCallback = searchCallback;
    this.removeDiacritics = removeDiacritics;
    this.canSearch = false;
    this.searching = null;
    this.searchTiming = 500;
    this.searchResult = [];
    this.inputValue = null;
    this.noRes = this.setupNoRes();
    this.searchLoader = this.setupSearchLoader();

    // scroll placeholder
    this.placeholder = this.setupPlaceholder();

    /**
     * TEMP PATCH
     * per i viewport pi� stretti mostro solo max 5 elementi
     * in un secondo momento, devo poter visualizzare la lista in alto/basso
     * in base alla posizione della select rispetto al viewport
     * e allo scroll del genitore...
     * */
    // we can either calculate it
    this.numberOfRows = numberOfRows ? numberOfRows : 5;
    this.optionsContainerHeight = Math.min(this.totalHeight, this.entryHeight * this.numberOfRows);

    if (this.optionsContainerHeight >= Math.round(window.innerHeight / 2.25)) {
      this.numberOfRows = 5;
      this.optionsContainerHeight = this.entryHeight * this.numberOfRows;
    }

    // options container
    this.optionsContainer = this.setupOptionsContainer();

    this.resizing;
    window.addEventListener("resize", (e) => {
      clearTimeout(this.resizing);
      this.resizing = setTimeout(() => {
        this.numberOfRows = numberOfRows ? numberOfRows : 5;
        this.optionsContainerHeight = Math.min(this.totalHeight, this.entryHeight * this.numberOfRows);

        if (this.optionsContainerHeight >= Math.round(window.innerHeight / 2.25)) {
          this.numberOfRows = 5;
          this.optionsContainerHeight = this.entryHeight * this.numberOfRows;
        }

        this.hideList();
        this.optionsContainer.style.setProperty("--h", `${this.optionsContainerHeight}px`);
      }, 100);
    });

    // scrolling offsets and indexes
    this.scrollTop = 0;
    this.multiplier = 1.5;
    this.idxStart, this.idxEnd, this.idxFocused, this.nVisibleEls, this.nVisibleElsInDOM, this.window;

    this.updateIndexes();

    // values
    this.currentFocusedOption = null;
    this.currentValue = null;

    // animations
    this.rendering = null;

    // callback
    this.callback = callback;

    if (!VirtualList.instances) {
      VirtualList.instances = [];
    }

    if (!VirtualList.instances.includes(this)) {
      VirtualList.instances.push(this);
    }
  }

  get value() {
    return this.currentValue;
  }

  set value(val) {
    this.currentValue = val;
    this.btnClearSelect?.style.setProperty("opacity", 1);
    this.btnClearSelect.setAttribute("tabindex", 0);

    if (this.select) {
      const opt = this.options.find((o) => o[this.valueKey] === this.currentValue);

      if (!opt) return;

      if (this.titleKey) {
        this.select.innerHTML = `<span class="label" title='${this.titleKey(this.currentValue)}'>${opt[this.labelKey]}</span>`;
      } else {
        this.select.innerHTML = `<span class="label" title="${opt[this.labelKey]}">${opt[this.labelKey]}</span>`;
      }
    }
  }

  updateIndexes() {
    let options = this.options;

    if (this.canSearch) {
      options = this.searchResult;
    }

    this.idxStart = Math.floor(this.scrollTop / this.entryHeight);
    this.idxEnd = Math.min(options.length, Math.floor((this.scrollTop + this.optionsContainerHeight) / this.entryHeight));
    this.idxFocused = 0;

    // sliding window
    this.window = options.slice(this.idxStart, Math.min(this.idxEnd, options.length));

    this.nVisibleEls = this.window.length + 2;
    this.nVisibleElsInDOM = Math.min(this.idxEnd, this.window.length);
    // console.log(this.idxStart, this.idxEnd, this.window, this.nVisibleEls, this.nVisibleElsInDOM);
  }

  init() {
    this.optionsContainer.appendChild(this.placeholder);

    if (this.isSelect) {
      this.container.classList.add("is-hidden");
      this.container.appendChild(this.select);
      this.container.appendChild(this.btnClearSelect);
    }

    if (this.hasSearch) {
      this.container.appendChild(this.inputSearch);
      this.container.classList.add("has-search");
    }

    this.container.appendChild(this.optionsContainer);
    this.container.style.setProperty("--entry-h", `${this.entryHeight}px`);

    this.render();

    this.optionsContainer.addEventListener("scroll", (e) => {
      let options = this.options;

      if (this.canSearch) {
        options = this.searchResult;
      }

      this.scrollTop = Math.round(this.optionsContainer.scrollTop);
      this.idxStart = Math.floor(this.scrollTop / this.entryHeight);
      this.idxEnd = this.idxStart + this.nVisibleEls;
      this.window = options.slice(this.idxStart, Math.min(this.idxEnd, options.length));

      this.render();
    });

    this.optionsContainer.addEventListener("wheel", (e) => {
      const prevSelected = this.optionsContainer.querySelector(".is-focused");
      prevSelected?.classList.remove("is-focused");
    });

    this.optionsContainer.addEventListener("keydown", (e) => {
      // keep default browser behaviour for shift & tab keys
      if (e.key !== "Tab" || !e.shiftKey) {
        e.preventDefault();
      }

      switch (e.key) {
        case "ArrowUp":
          this.onArrowUpPress();
          break;
        case "ArrowDown":
          this.onArrowDownPress();
          break;
        case "PageUp":
          this.onPageUpPress();
          break;
        case "PageDown":
          this.onPageDownPress();
          break;
        case "Home":
          this.onHomePress();
          break;
        case "End":
          this.onEndPress();
          break;
        case "Enter":
          this.onEnterPress();
          break;
      }
    });

    this.container.addEventListener("click", (e) => e.stopPropagation());
    this.container.addEventListener("keydown", (e) => {
      e.key === "Escape" && this.hideList();
    });

    /**
     * (ennesima) PATCH !!!
     * trova il contenitore pi� vicino con scroll
     * e setta le coordinate corrette della lista di options...
     * */
    let parent = this.findClosestScrollableParent(this.container.parentElement);

    if (Pqp.isNullOrEmpty(parent)) {
      parent = window;
    }

    parent.addEventListener("scroll", (e) => this.positionList());
  }

  findClosestScrollableParent(parent) {
    if (!parent) return;

    const styles = getComputedStyle(parent);

    if (styles.overflowY === "auto" || styles.overflowY === "scroll") {
      return parent;
    }

    return this.findClosestScrollableParent(parent.parentElement);
  }

  onEnterPress() {
    this.currentFocusedOption?.click();
  }

  onArrowUpPress() {
    const options = this.optionsContainer.querySelectorAll(".option");
    const prev = Array.from(options)?.find((o) => o.classList.contains("is-focused"));
    let opt = options[this.idxFocused];

    // if idx <= 0, force select on first row and reassign idx value accordingly
    if (this.idxFocused <= 0) {
      this.idxFocused = 0;

      if (!prev) {
        opt?.classList.add("is-focused");
        this.currentFocusedOption = opt ? opt : null;
      }

      const scrollTarget = (this.idxStart - 1) * this.entryHeight;
      this.scrollTo(scrollTarget);

      return;
    }

    if (!opt) {
      this.idxFocused = 0;

      return;
    }

    // if prev el does not exist, start from the first row
    if (!prev) {
      opt?.classList.add("is-focused");
      this.currentFocusedOption = opt ? opt : null;

      return;
    }

    // else go to the previous element in list
    this.idxFocused = Array.from(options).indexOf(prev) - 1;
    opt = options[this.idxFocused];
    this.currentFocusedOption = opt ? opt : null;
    prev.classList.remove("is-focused");
    opt?.classList.add("is-focused");
  }

  onArrowDownPress() {
    // if idx >= last el, force focus on last row and reassign idx value accordingly
    if (this.idxFocused >= this.nVisibleElsInDOM - 1) {
      this.idxFocused = this.nVisibleElsInDOM - 1;
      const scrollTarget = (this.idxStart + 1) * this.entryHeight;
      this.scrollTo(scrollTarget);

      return;
    }

    const options = this.optionsContainer.querySelectorAll(".option");
    const prev = Array.from(options)?.find((o) => o.classList.contains("is-focused"));
    let opt = options[this.idxFocused];

    if (!opt) {
      this.idxFocused = 0;

      return;
    }

    // if prev el does not exist, start from the first row
    if (!prev) {
      opt?.classList.add("is-focused");
      this.currentFocusedOption = opt ? opt : null;

      return;
    }

    // else go to the next element in list
    this.idxFocused = Array.from(options).indexOf(prev) + 1;
    opt = options[this.idxFocused];
    this.currentFocusedOption = opt ? opt : null;
    prev.classList.remove("is-focused");
    opt?.classList.add("is-focused");
  }

  onPageUpPress() {
    this.idxFocused = 0;
    const prev = this.optionsContainer.querySelector(".is-focused");
    const opt = this.optionsContainer.querySelector(".option");
    this.currentFocusedOption = opt;
    prev?.classList.remove("is-focused");
    opt.classList.add("is-focused");

    const scrollTarget = (this.idxStart - this.nVisibleElsInDOM) * this.entryHeight;
    this.scrollTo(scrollTarget);
  }

  onPageDownPress() {
    if (this.idxFocused !== this.nVisibleElsInDOM - 1) {
      this.idxFocused = this.nVisibleElsInDOM - 1;
    }

    const prev = this.optionsContainer.querySelector(".is-focused");
    prev?.classList.remove("is-focused");

    const options = this.optionsContainer.querySelectorAll(".option");
    const opt = options[this.nVisibleElsInDOM - 1];
    this.currentFocusedOption = opt;
    opt.classList.add("is-focused");

    const scrollTarget = (this.idxStart + this.nVisibleElsInDOM) * this.entryHeight;
    this.scrollTo(scrollTarget);
  }

  onHomePress() {
    const prev = this.optionsContainer.querySelector(".is-focused");
    const opt = this.optionsContainer.querySelector(".option");
    prev?.classList.remove("is-focused");
    this.currentFocusedOption = opt;
    opt.classList.add("is-focused");

    const scrollTarget = 0;
    this.scrollTo(scrollTarget, "auto");
  }

  onEndPress() {
    const prev = this.optionsContainer.querySelector(".is-focused");
    prev?.classList.remove("is-focused");

    const options = this.optionsContainer.querySelectorAll(".option");
    const opt = options[this.nVisibleElsInDOM - 1];
    this.currentFocusedOption = opt;
    opt.classList.add("is-focused");

    const scrollTarget = this.totalHeight;
    this.scrollTo(scrollTarget, "auto");
  }

  scrollTo(scrollTarget, behavior = "smooth") {
    this.optionsContainer.scrollTo({
      top: scrollTarget,
      left: 0,
      behavior: behavior,
    });
  }

  render() {
    if (!this.optionsContainer?.querySelectorAll(".option")?.length) {
      this.renderRows();
    } else {
      this.updateRows();
    }

    // render selected option
    const prevSelected = this.optionsContainer.querySelector(".is-selected");
    prevSelected?.classList.remove("is-selected");
    const opt = this.optionsContainer.querySelector(`[data-value="${this.currentValue}"]`);
    opt?.classList.add("is-selected");
  }

  renderRows() {
    for (let i = 0; i <= this.nVisibleEls; i++) {
      if (i > this.options.length - 1) break;

      const optionWrap = document.createElement("div");
      optionWrap.className = "option-wrap";
      //optionWrap.innerHTML = `<span class="label" title="${this.options[i][this.labelKey]}">${this.options[i][this.labelKey]}</span>`;

      if (this.titleKey) {
        //console.log(this.options[i]);
        optionWrap.innerHTML = `<span class="label" title='${this.titleKey(this.options[i].id)}'>${this.options[i][this.labelKey]}</span>`;
      } else {
        optionWrap.innerHTML = `<span class="label" title="${this.options[i][this.labelKey]}">${this.options[i][this.labelKey]}</span>`;
      }

      const option = document.createElement("div");
      option.dataset.value = this.options[i][this.valueKey];
      option.dataset.label = this.options[i][this.labelKey];
      option.className = "option";

      option.style.setProperty("position", "absolute");
      option.style.setProperty("top", `${i * this.entryHeight}px`);

      option.appendChild(optionWrap);
      option.addEventListener("click", (e) => this.handleOptionClick(e, option));

      i > this.nVisibleEls - 3 && option.style.setProperty("display", "none");

      this.optionsContainer.appendChild(option);
    }

    this.updateRows();
  }

  updateRows() {
    const rows = this.optionsContainer.querySelectorAll(".option");

    if (rows?.length < this.window.length) {
      rows?.forEach((row) => row.remove());
      this.renderRows();
    }

    for (let i = 0; i < this.window.length; i++) {
      if (i > rows?.length - 1) break;

      const row = this.window[i];
      rows[i].style.setProperty("display", "flex");
      rows[i].dataset.value = row[this.valueKey];
      rows[i].dataset.label = row[this.labelKey];
      rows[i].querySelector(".label").textContent = row[this.labelKey];
      //rows[i].querySelector(".label").setAttribute("title", `${row[this.labelKey]}`);

      if (this.titleKey) {
        rows[i].querySelector(".label").setAttribute("title", `${this.titleKey(row[this.valueKey])}`);
      } else {
        rows[i].querySelector(".label").setAttribute("title", `${row[this.labelKey]}`);
      }

      rows[i].style.setProperty("top", `${(this.idxStart + i) * this.entryHeight}px`);

      if (this.canSearch) {
        const markInstance = new Mark(rows[i]);
        markInstance.unmark({
          done: () => {
            markInstance.mark(this.inputValue);
          },
        });
      }
    }

    rows.forEach((row, i) => {
      const sibling = Array.from(rows).find((r, j) => {
        if (r.dataset.value === row.dataset.value && j > i) {
          return true;
        }
      });
      sibling?.style.setProperty("display", "none");
    });
  }

  handleOptionClick(e, option) {
    this.currentValue = option.dataset.value;

    if (this.isSelect) {
      if (this.titleKey) {
        this.select.innerHTML = `<span class="label" title="${this.titleKey(option.dataset.value)}">${option.dataset.label}</span>`;
      } else {
        this.select.innerHTML = `<span class="label" title="${option.dataset.label}">${option.dataset.label}</span>`;
      }
      this.btnClearSelect.style.setProperty("opacity", 1);
      this.btnClearSelect.setAttribute("tabindex", 0);
      this.hideList();
    } else {
      const selectedSiblings = this.optionsContainer.querySelectorAll(".is-selected");
      const focusedSiblings = this.optionsContainer.querySelectorAll(".is-focused");

      selectedSiblings?.forEach((s) => s.classList.remove("is-selected"));
      focusedSiblings?.forEach((s) => s.classList.remove("is-focused"));

      option.classList.add("is-selected", "is-focused");
      const options = this.optionsContainer.querySelectorAll(".option");
      this.idxFocused = Array.from(options)?.indexOf(option);
    }

    // dispatch event...
    this.callback?.call(null, {
      type: "change",
      data: null,
      target: this,
    });
  }

  setupOptionsContainer() {
    const optionsContainer = document.createElement("div");
    optionsContainer.classList.add("options-container");
    optionsContainer.style.setProperty("--h", `${this.optionsContainerHeight}px`);

    return optionsContainer;
  }

  setupPlaceholder() {
    const placeholder = document.createElement("div");
    placeholder.classList.add("placeholder");
    placeholder.style.setProperty("height", `${this.totalHeight}px`);

    return placeholder;
  }

  setupInputSearch() {
    const input = document.createElement("input");
    input.type = "text";
    input.setAttribute("placeholder", "Cerca...");
    input.addEventListener("input", (e) => this.handleInputSearch(e));

    // to refactor
    const btnClear = document.createElement("button");
    btnClear.classList.add("btn-clear-input", "js-btn-clear-input");
    btnClear.setAttribute("tabindex", "-1");
    btnClear.addEventListener("click", (e) => {
      input.value = "";
      const prevSelected = this.optionsContainer.querySelector(".is-selected");
      prevSelected?.classList.remove("is-selected");
      btnClear.setAttribute("tabindex", "-1");
      this.reset();
    });

    const inputSearch = document.createElement("div");
    inputSearch.className = "input-search";
    inputSearch.append(input, btnClear);

    return inputSearch;
  }

  handleInputSearch(e) {
    if (!e.target.value) {
      this.reset();
      this.container.querySelector(".js-btn-clear-input").setAttribute("tabindex", "-1");

      return;
    }

    const input = stringToTokenList(e.target.value, this.removeDiacritics);

    this.container.querySelector(".js-btn-clear-input").setAttribute("tabindex", 0);
    this.inputValue = e.target.value;
    this.canSearch = true;
    clearTimeout(this.searching);
    this.noRes.remove();
    this.emptyOptionsContainer();
    this.optionsContainer.appendChild(this.searchLoader);

    // actual search handler
    this.searching = setTimeout(() => {
      if (this.searchCallback) {
        this.searchResult = this.searchCallback(input, this.options);
      } else {
        // if there is no callback to use implement default search
        this.searchResult = this.searchOptions(input);
      }

      this.searchLoader.remove();
      console.log(this.searchResult);

      if (!this.searchResult.length) {
        this.optionsContainer.appendChild(this.noRes);

        return;
      }

      this.placeholder.style.setProperty("height", `${this.searchResult.length * this.entryHeight}px`);
      this.placeholder.style.setProperty("display", "block");
      this.updateIndexes();
      this.render();
    }, this.searchTiming);
  }

  reset() {
    clearTimeout(this.searching);
    this.canSearch = false;
    this.currentValue = null;
    this.idxFocused = 0;
    this.currentFocusedOption = null;
    this.searchResult = [];
    this.searchLoader.remove();
    this.noRes.remove();
    this.optionsContainer.querySelectorAll(".option")?.forEach((o) => o.remove());
    this.placeholder.style.setProperty("height", `${this.totalHeight}px`);
    this.placeholder.style.setProperty("display", "block");
    this.scrollTo(0, "instant");
    this.updateIndexes();
    this.render();

    if (this.isSelect) {
      this.select.innerHTML = `<span class="label" title="${this.defaultSelectLabel}">${this.defaultSelectLabel}</span>`;
      this.btnClearSelect.style.setProperty("opacity", 0);
      this.btnClearSelect.setAttribute("tabindex", "-1");
    }

    // dispatch event...
    this.callback?.call(null, {
      type: "change",
      data: null,
      target: this,
    });
  }

  searchOptions(input) {
    return this.options.filter((o) => {
      const label = stringToTokenList(o[this.labelKey]);
      return input.every((i) => label.some((l) => l.includes(i)));
    });
  }

  setupNoRes() {
    const noRes = document.createElement("div");
    noRes.classList.add("no-res");
    noRes.innerHTML = `<h2>Nessun risultato trovato!</h2>`;

    return noRes;
  }

  setupSearchLoader() {
    const loader = document.createElement("div");
    loader.classList.add("vs-loader");
    let i = 0;
    setInterval(() => {
      loader.textContent = `Cerco${".".repeat(i)}`;
      i = i + 1 > 3 ? 0 : i + 1;
    }, 250);

    return loader;
  }

  emptyOptionsContainer() {
    this.scrollTo(0, "instant");
    this.placeholder.style.setProperty("display", "none");
    this.optionsContainer.querySelectorAll(".option").forEach((o) => o.remove());
  }

  setupSelect() {
    const select = document.createElement("button");
    select.classList.add("btn", "btn-select");
    select.innerHTML = `<span class="label" title="${this.defaultSelectLabel}">${this.defaultSelectLabel}</span>`;
    select.addEventListener("click", (e) => {
      this.handleSelectClick(e);
    });

    return select;
  }

  handleSelectClick(e) {
    this.listVisible ? this.hideList() : this.showList();
  }

  setupBtnClearSelect() {
    const btn = document.createElement("button");
    btn.classList.add("btn", "btn-clear-select");
    btn.style.setProperty("opacity", 0);
    btn.setAttribute("tabindex", "-1");

    btn.addEventListener("click", (e) => {
      const prevSelected = this.optionsContainer.querySelector(".is-selected");
      prevSelected?.classList.remove("is-selected");

      if (this.hasSearch) {
        this.inputSearch.querySelector("input[type='text']").value = "";
      }

      this.reset();
    });

    return btn;
  }

  positionList() {
    const rect = this.container.getBoundingClientRect();
    const top = Math.floor(rect.top - this.optionsContainerHeight);
    const bottom = Math.floor(rect.bottom);
    const left = Math.floor(rect.x);
    const w = this.container.offsetWidth;

    this.container.style.setProperty("--left", `${left}px`);
    this.container.style.setProperty("--w", `${w}px`);

    // if it overflows the viewport, stick the list on top
    if (bottom + this.optionsContainerHeight > window.innerHeight) {
      this.container.style.setProperty("--top", `${top}px`);

      if (this.hasSearch) {
        this.inputSearch.style.setProperty("--top", `${rect.top - this.entryHeight}px`);
        this.optionsContainer.style.setProperty("--top", `${top - this.entryHeight}px`);
      }

      // else stick it to the bottom
    } else {
      this.container.style.setProperty("--top", `${bottom}px`);

      if (this.hasSearch) {
        this.inputSearch.style.removeProperty("--top");
        this.optionsContainer.style.setProperty("--top", `${bottom + this.entryHeight}px`);
      }
    }
  }

  showList() {
    this.positionList();

    // hide other lists
    VirtualList.instances.forEach((i) => {
      if (i !== this) {
        i.hideList();
      }
    });

    this.listVisible = true;

    this.container.classList.remove("is-hidden");
    this.optionsContainer.setAttribute("tabindex", 0);

    this.hasSearch ? this.inputSearch.querySelector("input[type='text']").focus() : this.optionsContainer.focus();

    const prevFocused = this.optionsContainer.querySelector(".is-focused");
    prevFocused?.classList.remove("is-focused");
    this.idxFocused = 0;

    // if a value is set scroll to its index
    if (this.currentValue) {
      const o = this.options.find((o) => o[this.valueKey] === this.currentValue);
      if (!o) return;

      const scrollTarget = this.options.indexOf(o) * this.entryHeight;
      this.scrollTo(scrollTarget, "instant");

      const opt = this.optionsContainer.querySelector(`[data-value="${this.currentValue}"]`);
      if (!opt) return;

      !opt.classList.contains("is-selected") && opt.classList.add("is-selected");
    }
  }

  hideList() {
    this.listVisible = false;

    clearTimeout(this.searching);
    this.canSearch = false;
    this.searchResult = [];
    this.searchLoader.remove();
    this.noRes.remove();
    this.optionsContainer.querySelectorAll(".option")?.forEach((o) => o.remove());
    this.placeholder.style.setProperty("height", `${this.totalHeight}px`);
    this.placeholder.style.setProperty("display", "block");
    this.scrollTo(0, "instant");
    this.updateIndexes();
    this.render();

    this.scrollTop = 0;

    if (this.inputSearch) {
      this.inputSearch.querySelector("input[type='text']").value = "";
    }

    this.canSearch = false;
    this.container.classList.add("is-hidden");
    this.optionsContainer.setAttribute("tabindex", -1);
  }

  destroy() {
    Array.from(this.container.children)?.forEach((c) => c.remove());
    VirtualList.instances = VirtualList.instances.filter((i) => i !== this);

    delete window[this];
  }
}
